(function () {
  function isPilot() {
    var vp = document.querySelector('variant-picker[data-product-handle]');
    return !!vp && vp.dataset.productHandle === 'cruze-x-rt';
  }
  if (!isPilot()) return;

  var LABELS = { en: 'Colour', de: 'Farbe', fr: 'Couleur', cs: 'Barva', it: 'Colore', pl: 'Kolor' };
  var PILL = {
    en: ['Tap to zoom and choose colour', 'Click to zoom and choose colour'],
    de: ['Zum Zoomen und Farbe wählen tippen', 'Zum Zoomen und Farbe wählen klicken'],
    fr: ['Touchez pour zoomer et choisir la couleur', 'Cliquez pour zoomer et choisir la couleur'],
    cs: ['Klepnutím přiblížíte a vyberete barvu', 'Kliknutím přiblížíte a vyberete barvu'],
    it: ['Tocca per zoomare e scegliere il colore', 'Clicca per zoomare e scegliere il colore'],
    pl: ['Dotknij, aby powiększyć i wybrać kolor', 'Kliknij, aby powiększyć i wybrać kolor']
  };
  var lg = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
  var label = LABELS[lg] || LABELS.en;
  var pillPair = PILL[lg] || PILL.en;
  var touch = window.matchMedia && matchMedia('(hover:none)').matches;
  var pillText = touch ? pillPair[0] : pillPair[1];

  // The colour choice now lives in the zoom viewer; hide the native picker here.
  var style = document.createElement('style');
  style.textContent =
    'fieldset.variant-option:has(input[data-option-name="Colour"]){display:none !important}' +
    '.rc-lb__colour{position:absolute;top:.75rem;left:.75rem;z-index:2;display:flex;flex-direction:column;gap:.3rem}' +
    '.rc-lb__colour label{color:rgba(255,255,255,.75);font:700 .72rem/1 Arial,sans-serif;text-transform:uppercase;letter-spacing:.04em}' +
    ".rc-lb__colour select{appearance:none;-webkit-appearance:none;-moz-appearance:none;min-width:9rem;padding:.6rem 2.2rem .6rem .9rem;border-radius:999px;border:1px solid rgba(255,255,255,.45);background:rgba(20,20,20,.9) url('data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 10 6%22%3E%3Cpath d=%22M1 1l4 4 4-4%22 fill=%22none%22 stroke=%22white%22 stroke-width=%221.6%22/%3E%3C/svg%3E') no-repeat right .9rem center;background-size:10px 6px;color:#fff;font:600 .95rem/1 Arial,sans-serif;cursor:pointer}" +
    '.rc-lb__colour select:focus-visible{outline:2px solid #fff;outline-offset:2px}' +
    '@media(max-width:480px){.rc-lb__colour{top:.6rem;left:.6rem}.rc-lb__colour select{min-width:7.5rem;font-size:.85rem}}';
  document.head.appendChild(style);

  function colourInputs() {
    return Array.prototype.slice.call(document.querySelectorAll('variant-picker input[data-option-name="Colour"]'));
  }

  function syncDropdown(select) {
    if (!select) return;
    var checked = colourInputs().filter(function (i) { return i.checked; })[0];
    if (checked) select.value = checked.value;
  }

  function injectDropdown(lb) {
    var existing = lb.querySelector('.rc-lb__colour select');
    if (existing) { syncDropdown(existing); return; }
    var inputs = colourInputs();
    if (!inputs.length) return;
    var wrap = document.createElement('div');
    wrap.className = 'rc-lb__colour';
    var lab = document.createElement('label');
    lab.setAttribute('for', 'rc-lb-colour-select');
    lab.textContent = label;
    var select = document.createElement('select');
    select.id = 'rc-lb-colour-select';
    inputs.forEach(function (input) {
      var opt = document.createElement('option');
      opt.value = input.value;
      opt.textContent = input.value;
      if (input.disabled) opt.disabled = true;
      select.appendChild(opt);
    });
    syncDropdown(select);
    select.addEventListener('change', function () {
      var match = colourInputs().filter(function (i) { return i.value === select.value; })[0];
      if (!match) return;
      match.checked = true;
      match.dispatchEvent(new Event('change', { bubbles: true }));
    });
    wrap.appendChild(lab);
    wrap.appendChild(select);
    lb.appendChild(wrap);
  }

  function scanLightbox() {
    var lb = document.querySelector('.rc-lb');
    if (lb && !lb.hidden) injectDropdown(lb);
  }

  new MutationObserver(scanLightbox).observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['hidden'],
    subtree: true,
    childList: true
  });
  scanLightbox();

  // Relabel the existing "tap/click to enlarge" pill for this product only.
  function relabelPill() {
    var pillEl = document.querySelector('.rc-zh7 span');
    if (pillEl && pillEl.textContent !== pillText) pillEl.textContent = pillText;
  }
  new MutationObserver(relabelPill).observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true
  });
  relabelPill();
  var n = 0;
  var t = setInterval(function () {
    relabelPill();
    if (++n > 60) clearInterval(t);
  }, 300);
})();
